module.exports = __webpack_public_path__ + "static/media/assign.1df2c6b3.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/assign.png
 ** module id = 2712
 ** module chunks = 0
 **/